import script from "./PlanetParade.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanetParade.vue?vue&type=script&setup=true&lang=ts"

import "./PlanetParade.vue?vue&type=style&index=0&id=17b31cb4&lang=less"

const __exports__ = script;

export default __exports__